// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"b0c068de","40":"6cc9df01","97":"d570b1ca","142":"b8cd5f0d","487":"22f9dd18","587":"963cacc4","741":"16906997","788":"b1ead931","959":"530753d6","963":"83762b29","993":"93f3570a"}[chunkId] + ".chunk.js";
};